import React from 'react';
import './App.css'; 
import BookingForm from './BookingForm';

const ContactUs = () => {
  return (
    <div className="contact-us">
     {/* <p>
        For general inquiries or to get in touch, please fill out the form below.
      </p> */}
      <BookingForm />
    </div>
  );
};

export default ContactUs;
